<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-1",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 21,
      // nextPage: this.nextPageUrl,
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'cardBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'Please select a nutritional goal.',
        subTitle: 'You can choose from 1-2.\nWe ask about 2 to 5 questions per goal.',
        mostChoice:  2,
        btn: [
          [
            {
              text: 'Immunity',
              icon: require('@/assets/icon/questionIcon/25-Immunity.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/25-Immunity.png'),
              operation: 'add product FM-WMV-101 & add product FM-ELDER-101'
            },{
              text: 'Digestion',
              icon: require('@/assets/icon/questionIcon/21-Digestion.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/25-Digestion.png'),
              operation: 'add product FM-PROBI-101'
            },{
              text: 'Skin',
              icon: require('@/assets/icon/questionIcon/21-Skin.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/25-Skin.png'),
              operation: 'add product FM-MCPEP-101 & add product FM-VCOLB-101'
            }
          ],[
            {
              text: 'Hair',
              icon: require('@/assets/icon/questionIcon/21-Hair.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/25-Hair.png'),
              operation: 'add product FM-VCOLB-101'
            },{
              text: 'Emotion',
              icon: require('@/assets/icon/questionIcon/21-Emotion.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/25-Emotion.png'),
            }
          ],[
            {
              text: 'Menstrual problems',
              icon: require('@/assets/icon/questionIcon/25-Immunity.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/25-Immunity.png'),
              operation: 'add product FM-EPOIL-101'
            },{
              text: 'Women\'s Health',
              icon: require('@/assets/icon/questionIcon/21-Women’s Health.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/25-Women’s Health.png'),
            }
          ]
        ],
      }
    }
  },
  computed: {
    nextPage: function(){
      if(this.$store.state.qsData[21] && this.$store.state.qsData[21].answer.length>0){
        if(this.$store.state.qsData[21].answer.indexOf('Immunity') !== -1){
          return '/questionnaire/section2/2'
        }else if(this.$store.state.qsData[21].answer.indexOf('Digestion') !== -1){
          return '/questionnaire/section2/7'
        }else if(this.$store.state.qsData[21].answer.indexOf('Skin') !== -1){
          return '/questionnaire/section2/9'
        }else if(this.$store.state.qsData[21].answer.indexOf('Hair') !== -1){
          return '/questionnaire/section2/11'
        }else if(this.$store.state.qsData[21].answer.indexOf('Emotion') !== -1){
          return '/questionnaire/section2/13'
        }else if(this.$store.state.qsData[21].answer.indexOf('Menstrual problems') !== -1){
          return '/questionnaire/section2/16'
        }else if(this.$store.state.qsData[21].answer.indexOf('Women\'s Health') !== -1){
          return '/questionnaire/section2/18'
        }else{
          return '/questionnaire/section2/1'
        }
      }else{
        return '/questionnaire/section2/1'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#qs21{
  .btnBlock{
    .btnBlockRow:last-of-type{
      width: 100%;
    }
  }
}
</style>
